import React, {useState} from "react";
import assets from "../assets/imgs";
import CommuteDetailModal from "./CommuteDetailModal";
import config from "../config/config";
const API_URL = config.API_URL;

function CommuteCalendar({style, checkResult}) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getMonthDays = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate(); // 이전 달의 마지막 날
    const lastDayOfMonth = new Date(year, month, daysInMonth).getDay(); // 마지막 날의 요일

    const days = [];
    // 이전 달의 빈 칸
    for (let i = firstDay - 1; i >= 0; i--) {
      days.push({ day: daysInPrevMonth - i, currentMonth: false });
    }
    // 현재 달의 날짜
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({ day: i, currentMonth: true });
    }
    // 다음 달 날짜 채우기 (마지막 요일 기준으로 필요한 칸만 채움)
    for (let i = 1; i < 7 - lastDayOfMonth; i++) {
      days.push({ day: i, currentMonth: false });
    }

    return days;
  };

  console.log('currdata ', currentDate);

  // const checkResult = [
  //   { date: new Date("2025-02-03"), complete: 2 , doing: 1},
  //   { date: new Date("2025-02-10"), complete: 2 , doing: 0},
  //   { date: new Date("2025-02-15"), complete: 1 , doing: 1},
  // ];

  const handlePrevMonth = () => {
    const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    setCurrentDate(prevMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    setCurrentDate(nextMonth);
  };

  // 날짜 클릭 핸들러
  const handleDateClick = async (dateObj) => {
    if (!dateObj.currentMonth) return; // 다른 달의 날짜는 클릭 불가

    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(dateObj.day).padStart(2, '0')}`;

    // 해당 날짜에 출퇴근 기록이 있는지 확인
    const hasRecord = checkResult.some(result => {
      const resultDate = new Date(result.date);
      return (
        resultDate.getFullYear() === year &&
        resultDate.getMonth() === month &&
        resultDate.getDate() === dateObj.day
      );
    });

    if (!hasRecord) {
      return; // 기록이 없으면 모달을 띄우지 않음
    }

    setSelectedDate(dateStr);
    setLoading(true);
    setShowModal(true);

    try {
      const response = await fetch(
        `${API_URL}/api/commute/getCommuteDayDetail?date=${dateStr}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setDetailData(data.data);
      } else {
        console.error("Failed to fetch commute detail");
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error fetching commute detail:", error);
      setShowModal(false);
    } finally {
      setLoading(false);
    }
  };

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const days = getMonthDays(year, month);


  return (
    <div className="commonComponent" style={{...style, padding: "20px"}}>
      {/* 상단 네비게이션 */}
      <div style={styles.calendarHead}>
        <button style={styles.calendarHeadButton} onClick={handlePrevMonth}>
          <assets.icons.chevron_left style={{ color: "var(--grayscale-cool_100)"}}/>
        </button>
        <div style={styles.titleSection}>
          <img src={assets.icons.calendar} style={{width: "20px"}}/>
          <p style={styles.calendarTitle}>{year}.{String(month + 1).padStart(2, "0")}</p>
        </div>
        <button style={styles.calendarHeadButton} onClick={handleNextMonth}>
          <assets.icons.chevron_right style={{ color: "var(--grayscale-cool_100)"}}/>
        </button>
      </div>
      {/* 요일 */}
      <div style={styles.calendarContents}>
        <div style={styles.calendarDayTop}>
          {["일", "월", "화", "수", "목", "금", "토"].map((day) => (
            <div key={day} className="font-body3-semibold" style={{...styles.dayName,
              color: day === "토" ? "#376DFF" : day === "일" ? "#FF6258" : "#676767"
            }}>
              {day}
            </div>
          ))}
        </div>
        {/* 날짜 */}
        <div style={styles.calendarDay}>
          {days.map((item, index) => {
            const currentDate = new Date(year, month, item.day);
            const today = new Date();

            // 해당 날짜의 checkResult 찾기
            const matchedResult = checkResult.find(
              (result) =>{
                const resultDate = new Date(result.date);
                return (
                  resultDate.getFullYear() === currentDate.getFullYear() &&
                  resultDate.getMonth() === currentDate.getMonth() &&
                  resultDate.getDate() === currentDate.getDate()
                );
              }
                // result.date.getFullYear() === currentDate.getFullYear() &&
                // result.date.getMonth() === currentDate.getMonth() &&
                // result.date.getDate() === currentDate.getDate()
            );
            // 오늘 날짜인지 확인
            const isToday =
              currentDate.getFullYear() === today.getFullYear() &&
              currentDate.getMonth() === today.getMonth() &&
              currentDate.getDate() === today.getDate();

            const hasRecord = matchedResult !== undefined;

            return (
              <div
                key={index}
                className="font-body2-semibold"
                style={{...styles.dateBox,
                  paddingTop: isToday ? "11px" : "16px",
                  cursor: (hasRecord && item.currentMonth) ? "pointer" : "default",
                }}
                onClick={() => handleDateClick(item)}
              >
                <p style={{...styles.dateTitle,
                  ...(item.currentMonth ? {} : styles.falseDateTitle),
                  ...((isToday && item.currentMonth) ? styles.todayDate : {})}}>
                  {item.day}</p>

                {/* 출퇴근 시간 표시 */}
                {matchedResult && item.currentMonth && (
                  <div style={styles.timeDisplaySection}>
                    {matchedResult.checkIn && (
                      <div style={styles.timeRow}>
                        <span style={styles.timeLabel}>출</span>
                        <span style={styles.timeValue}>{matchedResult.checkIn.time}</span>
                        {matchedResult.checkIn.isOutside && (
                          <span style={styles.outsideBadgeSmall}>외</span>
                        )}
                      </div>
                    )}
                    {matchedResult.checkOut && (
                      <div style={styles.timeRow}>
                        <span style={styles.timeLabel}>퇴</span>
                        <span style={styles.timeValue}>{matchedResult.checkOut.time}</span>
                        {matchedResult.checkOut.isOutside && (
                          <span style={styles.outsideBadgeSmall}>외</span>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* 출퇴근 상세 모달 */}
      {showModal && detailData && !loading && (
        <CommuteDetailModal
          date={selectedDate}
          data={detailData}
          onClose={() => {
            setShowModal(false);
            setDetailData(null);
            setSelectedDate(null);
          }}
        />
      )}
    </div>
  );
}

const commonPoint ={
  width: "10px",
  height: "10px",
  borderRadius: "50%",
}

const styles ={
  calendarHead:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    // height: "51px",
    boxSizing: "border-box",
  },
  titleSection:{
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  calendarTitle:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight:"27px",
    color: "var(--text-color_90)",
    borderRadius: "20px 20px 0px 0px",
  },
  calendarHeadButton:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "20px",
    height: "20px",
    cursor: "pointer",
    borderRadius: "50%",
    backgroundColor: "#F3F3F8",
    padding: "0",
    border: "0px",
  },
  calendarContents:{
  },
  calendarDayTop:{
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    textAlign: "center",
    backgroundColor: "var(--grayscale_20)",
    borderRadius: "8px 8px 0px 0px"
  },
  calendarDay:{
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    textAlign: "center",
  },
  dayName :{
    // width: "94px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dateBox:{
    border: "1px solid var(--grayscale_30)",
    // width: "94px",
    height: "124px",
    display: "flex",
    flexDirection : "column",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "8px",
    padding: "16px",
    boxSizing: "border-box",
  },
  dateTitle:{
    width: "35px",
    height: "auto",
    textAlign:"center",
    color: "#676767",
    display: "flex",
    justifyContent:"center",
    alignItems: "center"
  },
  todayDate:{
    backgroundColor: "#F9D7E0",
    height : "35px",
    color: "var(--grayscale_90)",
    borderRadius: "50%",
  },
  falseDateTitle:{
    color: "var(--text-color_30)",
  },
  emptyDate: {
    backgroundColor: "transparent",
    color: "transparent",
    pointerEvents: "none",
  },
  checkPointSection:{
    display:"flex",
    flexWrap: 'wrap',
    gap:"8px"
  },
  checkPoint:{
    ...commonPoint,
    backgroundColor: "var(--primary-crimson_60)",
  },
  doingPoint:{
    ...commonPoint,
    backgroundColor: "var(--grayscale-cool_40)",
  },
  timeDisplaySection: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100%",
  },
  timeRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    fontSize: "11px",
  },
  timeLabel: {
    fontWeight: "600",
    color: "#666",
    minWidth: "14px",
  },
  timeValue: {
    fontWeight: "500",
    color: "#232323",
  },
  outsideBadgeSmall: {
    fontSize: "9px",
    color: "#FF8A00",
    backgroundColor: "#FFF4E6",
    padding: "2px 4px",
    borderRadius: "3px",
    fontWeight: "600",
  }

}

export default CommuteCalendar;